import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { OverviewService } from '../service/overview.service';
var EditOverviewComponent = /** @class */ (function () {
    function EditOverviewComponent(_matDialogRef, data, _overviewService) {
        this._matDialogRef = _matDialogRef;
        this._overviewService = _overviewService;
        this.isLoading = false;
        this.website = data.website || '';
        this.airportID = data.airportID;
        this.originalWebsite = data.website || '';
        this.selectedWebsite = this.website;
    }
    EditOverviewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this.close({ cancelBtnClicked: true });
        });
        this.formGroup = new FormGroup({
            website: new FormControl(this.selectedWebsite, [Validators.maxLength(120),
                Validators.pattern('^(http:\\/\\/www\\.|https:\\/\\/www\\.|http:\\/\\/|https:\\/\\/)?[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$')])
        });
    };
    /**
     * triggered by save button click event
     * @return {Promise<void>}
     */
    EditOverviewComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        res = void 0;
                        this.website = this.formGroup.get('website').value;
                        return [4 /*yield*/, this._overviewService.putOverview(this.airportID, this.website)];
                    case 1:
                        res = _a.sent();
                        // Object.assign(this.fuel, BusinessFuel.parse(res));
                        this.close({ cancelBtnClicked: false, success: true, website: this.website });
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * triggered by cancel button click event
     */
    EditOverviewComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    /**
     * closes modal
     * @param data
     */
    EditOverviewComponent.prototype.close = function (data) {
        if (data && data.cancelBtnClicked) {
            this.website = this.originalWebsite;
        }
        this._matDialogRef.close(data);
    };
    return EditOverviewComponent;
}());
export { EditOverviewComponent };
